import styled from "styled-components";

import dot from '@/images/vip-progress-dot.png'
import progressBg from '@/images/vip-progress.png'
import star from '@/images/vip-progress-star.png'

const View = styled.div`
  position: absolute;
  left: 0;
  top: 740px;
  width: 100%;
  height: 340px;

  & > p {
    position: absolute;
    top: 29px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
    color: #facf53;
  }

  & > .main {
    width: 900px;
    height: 250px;
    margin: 70px auto 0;
    position: relative;

    div.item {
      width: 115px;
      height: 250px;
      text-align: center;
      position: relative;
      display: inline-block;
      margin-right: 81px;
      vertical-align: top;

      div.button {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);

      }

      &:nth-child(6) {
        margin-right: 0;
        float: right;
      }

      p {
        width: 100%;
      }

      p:nth-child(2) {
        font-size: 14px;
        color: #033085;
        margin-top: 7px;
      }

      p:nth-child(3) {
        font-size: 16px;
        color: #ffffff;
        margin-top: 10px;
      }

      div.star {
        width: 50px;
        height: 50px;
        position: absolute;
        left: 50%;
        top: 162px;
        transform: translateX(-50%);
        background-image: url("${dot}");

        &.active {
          background-image: url("${star}");
        }
      }
    }
  }
`;

const Progress = styled.div.attrs((props) => ({
  step: props.step
}))`
  width: ${props => [0, 55, 250, 450, 650, 900][props.step]}px;
  background-image: url("${progressBg}");
  background-repeat: repeat-x;
  height: 12px;
  border-radius: 6px;
  position: absolute;
  max-width: calc(100% - 8px);
  left: 4px;
  top: 182px;
`

export {
  View,
  Progress
}
